import InputFind from './InputFind.vue';

InputFind.install = (Vue) => {
  Vue.component(InputFind.name, InputFind);
};

export default InputFind;
